<template>
  <div>
    <button
      class="d-none"
      data-toggle="modal"
      data-target="#newHotel"
      ref="openModalNewHotel"
      @click="dataReset()"
    ></button>
    <div class="modal fade" tabindex="-1" role="dialog" id="newHotel">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title m-0">New Hotel</h6>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeNewHotel"
              @click="closeModal()"
            >
              <img src="../../../assets/Svg/close.svg" />
            </button>
          </div>
          <div class="modal-body">
            <form @keyup.enter="saveHotel(0)" @submit.prevent>
              <div class="profile-preview mb-3">
                <div class="team-image-create custom-image">
                  <!-- <img
                    v-if="user.picture == 'yes'"
                    :src="API_URL + user.id + '/profile_picture.jpg?v=' + time"
                    alt=""
                  /> -->
                  <img
                    src="../../../assets/Svg/default.svg"
                    class="default-image"
                    alt=""
                    v-if="!photoUrl"
                  />

                  <form>
                    <input
                      type="file"
                      id="vue-file-upload-input-hotel-photo"
                      @change="onFileChange"
                      class="d-none"
                      accept="image/png, image/gif, image/jpeg"
                    />

                    <div id="preview" class="new-profile-photo">
                      <clipper-basic
                        :src="photoUrl"
                        preview="preview"
                        :border="4"
                        :outline="0"
                        :corner="false"
                        :ratio="1"
                        :wrap-ratio="1"
                        :init-width="50"
                        :init-height="50"
                        ref="clipper"
                      ></clipper-basic>
                    </div>

                    <div class="edit-icon-wrapper" @click="openinput()">
                      <img
                        src="../../../assets/Svg/team/team-options/edit-2.svg"
                        alt=""
                      />
                    </div>
                  </form>
                </div>
                <div clas="d-flex flex-column">
                  <h6>Preview</h6>
                  <div class="preview-image">
                    <div v-if="photoUrl">
                      <clipper-preview name="preview"></clipper-preview>
                    </div>

                    <!-- <div class="no-image-wrapper" v-else>
                      <div slot="placeholder">No image</div>
                    </div> -->
                  </div>
                </div>
              </div>
              <div class="form-group">
                <input
                  id="name"
                  class="form-control"
                  v-model.trim="$v.name.$model"
                  spellcheck="false"
                  autocomplete="off"
                  trim
                  type="text"
                  required
                  :class="{
                    'is-invalid': $v.name.$error,
                    'is-valid': !$v.name.$invalid,
                  }"
                />
                <span class="placeholder">Hotel Name</span>
                <div v-if="!$v.name.required" class="invalid-tooltip">
                  Hotel name is required
                </div>
                <div v-if="!$v.name.maxLength" class="invalid-tooltip">
                  Maximum 250 characters allowed.
                </div>
              </div>
              <div class="row no-gutters">
                <div class="col-12 col-md-6 pr-0 pr-md-3">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="url"
                      v-model="url"
                      @input="change($event)"
                      @change="change($event)"
                      required
                      @keyup="$v.url.$touch()"
                      :class="{
                        filled: url,
                        'is-invalid': $v.url.$error,
                        'is-valid': !$v.url.$invalid && $v.url.$model,
                      }"
                    />
                    <span class="placeholder">Website URL</span>
                    <span
                      v-if="url && !$v.url.urlValidator"
                      class="invalid-tooltip"
                    >
                      URL is invalid
                    </span>
                    <span v-if="!$v.url.required" class="invalid-tooltip">
                      URL is required
                    </span>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="form-group">
                    <input
                      id="mob_phone"
                      class="form-control"
                      v-model.trim="$v.details.mob.$model"
                      v-phone-mask
                      spellcheck="false"
                      autocomplete="off"
                      :class="{
                        'is-invalid': validationStatus($v.details.mob),
                      }"
                      trim
                      required
                      type="text"
                      @keydown.backspace="handleDelete"
                    />
                    <span class="placeholder">Contact Number</span>
                    <div v-if="!$v.details.mob.minLength" class="invalid-tooltip">
                      Minimum length should be 11
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <gmap-autocomplete
                      :value="location"
                      placeholder="Enter an address, zipcode, or location"
                      @place_changed="setPlace"
                      ref="autocompleteRef"
                    >
                    </gmap-autocomplete>
                  </div>
                </div>
                <div class="col-12">
                  <google-map
                    :center="marker.position"
                    :zoom="18"
                    map-style-id="roadmap"
                    :options="mapOptions"
                    style="width: 100vmin; height: 40vmin; margin-bottom: 10px"
                    ref="mapRef"
                    id="map"
                    @click="handleMapClick"
                  >
                    <google-maps-marker
                      :position="marker.position"
                      :clickable="true"
                      :draggable="true"
                      @drag="handleThrottledMarkerDrag"
                      @click="panToMarker"
                    ></google-maps-marker>
                  </google-map>
                  <div class="form-group" :class="{ filled: street }">
                    <input
                      type="text"
                      class="form-control"
                      id="street"
                      v-model="street"
                      required
                      :class="{
                        'is-invalid': $v.street.$error,
                        'is-valid': !$v.street.$invalid,
                      }"
                    />
                    <span v-if="!$v.street.required" class="invalid-tooltip">
                      Street address is required
                    </span>
                    <span class="placeholder">Street Address</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-4 pr-md-2">
                  <div class="form-group" :class="{ filled: city }">
                    <input
                      type="text"
                      class="form-control"
                      id="city"
                      v-model="city"
                      required
                      :class="{
                        'is-invalid': $v.city.$error,
                        'is-valid': !$v.city.$invalid,
                      }"
                    />
                    <span v-if="!$v.city.required" class="invalid-tooltip">
                      City is required
                    </span>
                    <span class="placeholder">City</span>
                  </div>
                </div>
                <div class="col-12 col-md-4 px-md-0">
                  <div class="form-group" :class="{ filled: state }">
                    <input
                      type="text"
                      class="form-control"
                      id="state"
                      v-model="state"
                      required
                      :class="{
                        'is-invalid': $v.state.$error,
                        'is-valid': !$v.state.$invalid,
                      }"
                    />
                    <span v-if="!$v.state.required" class="invalid-tooltip">
                      State is required
                    </span>
                    <span class="placeholder">State</span>
                  </div>
                </div>
                <div class="col-12 col-md-4 pl-md-2">
                  <div class="form-group" :class="{ filled: zipCode }">
                    <input
                      type="number"
                      class="form-control"
                      id="zipCode"
                      v-model="zipCode"
                      @keydown="preventDot"
                      required
                      :class="{
                        'is-invalid': $v.zipCode.$error,
                        'is-valid': !$v.zipCode.$invalid,
                      }"
                    />
                    <span v-if="!$v.zipCode.required" class="invalid-tooltip">
                      Zipcode is required
                    </span>
                    <span class="placeholder">Zip Code</span>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="event-btns-wrapper justify-content-end">
            <button
              type="button"
              class="btn btn-primary"
              @click="saveHotel(0)"
              :disabled="isLoadingArray[0]"
            >
              <div v-if="isLoadingArray[0]" class="lds-dual-ring"></div>
              <div v-else>
                <img
                  class="mr-1"
                  src="../../../assets/Svg/save.svg"
                  alt="save"
                />Save
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required, maxLength, minLength } from "vuelidate/lib/validators";
import { clipperBasic, clipperPreview } from "vuejs-clipper";
import _ from "lodash";
import axios from "axios";

const urlValidator = (value) => {
  if (!value) return true; // Let 'required' handle empty fields

  const regx = new RegExp(
    "^" +
      "(?:(?:https?|http)://)?" +
      "(?:\\S+(?::\\S*)?@)?" +
      "(?:" +
      "(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
      "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
      "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +
      "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
      "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
      "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
      "|" +
      "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" +
      "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" +
      "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))" +
      ")" +
      "(?::\\d{2,5})?" +
      "(?:/\\S*)?" +
      "$",
    "i"
  );

  return regx.test(value);
};

export default {
  name: "NewHotel",
  components: {
    clipperBasic,
    clipperPreview,
  },
  props: {
    eventId: {
      type: [Number, String],
    },
    association_id: {
      type: [Number, String],
    },
  },
  data() {
    return {
      hotelData: {},
      isLoadingArray: [],
      details: {
        mob: "",
      },
      name: "",
      url: "",
      photoUrl: null,
      isValid: false,
      hotelPhoto: null,
      location: null,
      marker: { position: { lat: 10, lng: 10 } },
      markers: [],
      center: { lat: 10, lng: 10 },
      mapOptions: {
        disableDefaultUI: false,
        gestureHandling: "cooperative", // allows zooming only with Ctrl + wheel on desktop
        disableDoubleClickZoom: true, // disables zoom on double-click
      },
      city: "",
      state: "",
      zipCode: "",
      street: "",
    };
  },
  validations: {
    details: {
      mob: { minLength: minLength(11) },
    },
    name: { required, maxLength: maxLength(250) },
    url: { required, urlValidator },
    street: { required },
    city: { required },
    state: { required },
    zipCode: { required },
  },

  methods: {
    validationStatus: function(validation) {
      return typeof validation != "undefined" ? validation.$error : false;
    },
    preventDot(event) {
      const invalidKeys = ["e", "E", ".", "+", "-"];
      if (invalidKeys.includes(event.key)) {
        event.preventDefault();
      }
    },
    handleDelete(event) {
      const input = event.target;
      const cursorPos = input.selectionStart;
      const value = this.phonedetails.mob;

      const formattingChars = ["(", ")", " ", "-"];
      const isAfterFormattingChar =
        (cursorPos > 0 && formattingChars.includes(value[cursorPos - 1])) ||
        (event.key === "Delete" &&
          cursorPos < value.length &&
          formattingChars.includes(value[cursorPos]));

      if (isAfterFormattingChar) {
        event.preventDefault(); // Prevent default deletion

        let newValue;
        if (event.key === "Backspace") {
          newValue =
            value.substring(0, cursorPos - 1) + value.substring(cursorPos);
          this.phonedetails.mob = newValue;
          input.value = newValue; // also update input directly

          this.$nextTick(() => {
            input.setSelectionRange(cursorPos - 1, cursorPos - 1);
          });
        } else if (event.key === "Delete") {
          newValue =
            value.substring(0, cursorPos) + value.substring(cursorPos + 1);
          this.phonedetails.mob = newValue;
          input.value = newValue; // also update input directly

          this.$nextTick(() => {
            input.setSelectionRange(cursorPos, cursorPos);
          });
        }
      }
    },
    handleThrottledMarkerDrag: _.throttle(function(event) {
      this.handleMarkerDrag(event);
    }, 50),
    handleMarkerDrag(e) {
      window.test = this;
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      var geocoder = new window.google.maps.Geocoder();
      var latlng = this.marker.position;
      geocoder.geocode({ location: latlng }, function(results, status) {
        if (status === "OK") {
          if (results[1]) {
            for (let i = 0; i < results.length; i++) {
              // eslint-disable-next-line
              window.test.location = results[2].formatted_address;
              if (results[i]?.types[0] == "locality") {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (
                    results[i].address_components[j]?.types[0] == "locality"
                  ) {
                    window.test.city =
                      results[i].address_components[j].long_name;
                  }
                }
                // this.city = results[i].long_name;
              }
              if (
                results[i]?.types[0] == "premise" ||
                results[i]?.types[0] == "street_address" ||
                results[i]?.types[0] == "route" ||
                results[i]?.types[0] == "neighborhood"
              ) {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (
                    results[i].address_components[j]?.types[0] == "route" ||
                    results[i].address_components[j]?.types[0] ==
                      "street_address" ||
                    results[i].address_components[j]?.types[0] == "premise"
                  ) {
                    window.test.street =
                      results[i].address_components[j].long_name;
                  }
                }
              }
              if (results[i]?.types[0] == "administrative_area_level_1") {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (
                    results[i].address_components[j]?.types[0] ==
                    "administrative_area_level_1"
                  ) {
                    window.test.state =
                      results[i].address_components[j].long_name;
                  }
                }
              }
              if (results[i]?.types[0] == "postal_code") {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (
                    results[i].address_components[j]?.types[0] == "postal_code"
                  ) {
                    window.test.zipCode =
                      results[i].address_components[j].long_name;
                  }
                }
              }
            }
          } else {
            window.alert("No results found");
          }
        }
      });
    },
    setPlace(place) {
      if (!place) return;
      this.$refs.autocompleteRef.$el.classList.add("custom-dropdown-open");
      this.marker.position = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      this.street = place.formatted_address;
      this.location = place.formatted_address;

      const addressComponents = place.address_components;

      for (const component of addressComponents) {
        const types = component.types;
        if (types.includes("locality")) {
          this.city = component.long_name;
        } else if (types.includes("administrative_area_level_1")) {
          this.state = component.short_name;
        } else if (types.includes("postal_code")) {
          this.zipCode = component.long_name;
        }
      }
      this.panToMarker();
    },
    panToMarker() {
      if (this.marker?.position) {
        this.$refs.mapRef?.panTo(this.marker.position);
      }
    },
    handleMapClick(e) {
      window.test = this;
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      var geocoder = new window.google.maps.Geocoder();
      var latlng = this.marker.position;
      geocoder.geocode({ location: latlng }, function(results, status) {
        if (status === "OK") {
          if (results[0]) {
            for (let i = 0; i < results.length; i++) {
              // eslint-disable-next-line
              window.test.location = results[2].formatted_address;
              if (results[i]?.types[0] == "locality") {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (
                    results[i].address_components[j]?.types[0] == "locality"
                  ) {
                    window.test.city =
                      results[i].address_components[j].long_name;
                  }
                }
                // this.city = results[i].long_name;
              }
              if (
                results[i]?.types[0] == "premise" ||
                results[i]?.types[0] == "street_address" ||
                results[i]?.types[0] == "route"
              ) {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (
                    results[i].address_components[j]?.types[0] == "route" ||
                    results[i].address_components[j]?.types[0] ==
                      "street_address" ||
                    results[i].address_components[j]?.types[0] == "premise"
                  ) {
                    window.test.street =
                      results[i].address_components[j].long_name;
                  }
                }
              }
              if (results[i]?.types[0] == "administrative_area_level_1") {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (
                    results[i].address_components[j]?.types[0] ==
                    "administrative_area_level_1"
                  ) {
                    window.test.state =
                      results[i].address_components[j].long_name;
                  }
                }
              }
              if (results[i]?.types[0] == "postal_code") {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (
                    results[i].address_components[j]?.types[0] == "postal_code"
                  ) {
                    window.test.zipCode =
                      results[i].address_components[j].long_name;
                  }
                }
              }
            }
          } else {
            window.alert("No results found");
          }
        }
      });
    },
    dataReset: function() {
      this.name = "";
      this.details.mob = "";
      this.url = "";
      this.$v.$reset();
      this.state = "";
      this.location = null;
      this.zipCode = "";
      this.street = "";
      this.city = "";
      this.hotelPhoto = null;
      this.photoUrl = null;
      this.marker.position = { lat: 10, lng: 10 }; // reset marker position if necessary
      document.getElementById("vue-file-upload-input-hotel-photo").value = "";
    },

    change(e) {
      const url = e.target.value;
      this.isURLValid(url);
    },
    isURLValid(inputUrl) {
      var regx = new RegExp(
        "^" +
          // optional protocol identifier
          "(?:(?:https?|http)://)?" +
          // user:pass authentication
          "(?:\\S+(?::\\S*)?@)?" +
          "(?:" +
          // IP address exclusion
          // private & local networks
          "(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
          "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
          "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +
          // IP address dotted notation octets
          // excludes loopback network 0.0.0.0
          // excludes reserved space >= 224.0.0.0
          // excludes network & broacast addresses
          // (first & last IP address of each class)
          "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
          "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
          "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
          "|" +
          // host name
          "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" +
          // domain name
          "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" +
          // TLD identifier
          "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))" +
          ")" +
          // port number
          "(?::\\d{2,5})?" +
          // resource path
          "(?:/\\S*)?" +
          "$",
        "i"
      );
      this.isValid = regx.test(inputUrl);
    },

    openinput: function() {
      document.getElementById("vue-file-upload-input-hotel-photo").click();
    },
    onFileChange(e) {
      var fileInput = document.getElementById(
        "vue-file-upload-input-hotel-photo"
      );
      var file_ = fileInput.value;
      var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
      if (!allowedExtensions.exec(file_)) {
        alert(
          "Please upload file having extensions .jpeg/.jpg/.png/.gif only."
        );
        fileInput.value = "";
        return false;
      } else {
        this.hotelPhoto = e.target.files[0];

        this.compressImage(this.hotelPhoto, 0.5, (compressedImage) => {
          this.photoUrl = URL.createObjectURL(compressedImage);
          this.hotelPhoto = compressedImage;
        });
      }
    },
    compressImage(file, quality, callback) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          const maxWidth = 800;
          const maxHeight = 800;
          let width = img.width;
          let height = img.height;

          if (width > height) {
            if (width > maxWidth) {
              height = Math.round((height * maxWidth) / width);
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width = Math.round((width * maxHeight) / height);
              height = maxHeight;
            }
          }

          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
          canvas.toBlob(
            (blob) => {
              callback(blob);
            },
            "image/jpeg",
            quality
          );
        };
      };
    },

    closeModal() {
      this.dataReset();
      var elem = this.$refs.closeNewHotel;
      if (elem) {
        elem.click();
        setTimeout(() => {
          this.$emit("open-main-modal-again");
        }, 500);
      }
    },
    async saveHotel(index) {
      this.$v.$touch();
      if (this.$v.$pendding || this.$v.$error) return;

      if (this.$v.$invalid) {
        return;
      }
      // Set loading indicator
      this.$set(this.isLoadingArray, index, true);

      // Create a new FormData object
      let formData = new FormData();

      // Append data to the FormData object
      formData.append("event_id", this.eventId);
      formData.append("association_id", this.association_id);
      formData.append("name", this.name);
      formData.append("website_url", this.url);
      formData.append("address_description", this.location);
      formData.append("phone_number", this.details.mob);
      formData.append("latitude", this.marker.position.lat);
      formData.append("longitude", this.marker.position.lng);
      formData.append("street_address", this.street);
      formData.append("city", this.city);
      formData.append("state", this.state);
      formData.append("zip", this.zipCode);

      if (this.hotelPhoto) {
        if (this.$refs.clipper) {
          try {
            // Get cropped canvas from clipper
            const canvas = this.$refs.clipper.clip();
            // Convert canvas to blob
            const blob = await new Promise((resolve) => {
              canvas.toBlob((blob) => {
                resolve(blob);
              }, "image/png");
            });

            // Create a file from the blob
            const croppedFile = new File(
              [blob],
              this.hotelPhoto.fileName || "cropped-image.png",
              {
                type: "image/png",
              }
            );

            formData.append("image_url", croppedFile);
          } catch (error) {
            console.error("Error processing cropped image:", error);
            // Fallback to original image if cropping fails
            this.hotelPhoto.forEach((value) => {
              formData.append("image_url", value.target);
            });
          }
        } else {
          // Use original image if clipper isn't available
          this.hotelPhoto.forEach((value) => {
            formData.append("image_url", value.target);
          });
        }
      }

      try {
        // Make the API request
        const response = await axios.post(
          "/associationEvent/addEventHotel",
          formData
        );

        // Handle response based on statusCode
        if (response.data.statusCode === 200) {
          // Successful response

          this.$root.$emit("hotelAddedEmit");
          this.closeModal();
        } else if (response.data.statusCode === 404) {
          // Handle unauthorized access
          this.$alert(response.data.message, "Error");
          this.$router.push({ name: "Teams" });
          this.closeModal();
        } else {
          // Handle other statuses
          console.error(
            "Error: ",
            response.data.message || "Unknown error occurred"
          );
          this.$alert(
            response.data.message || "An error occurred while adding the hotel",
            "Error"
          );
        }
      } catch (error) {
        // Handle network errors
        console.error("Network Error: ", error);
        this.$alert(
          "An error occurred while adding the hotel. Please try again later.",
          "Network Error"
        );
      } finally {
        // Remove loading indicator
        this.$set(this.isLoadingArray, index, false);
      }
    },
    getAddressParts(addressComponents) {
      const get = (type) =>
        addressComponents.find((c) => c.types.includes(type))?.long_name || "";

      return {
        street: `${get("plus_code")} ${get("route")}`.trim(),
        city:
          get("locality") ||
          get("sublocality") ||
          get("administrative_area_level_2"),
        state: get("administrative_area_level_1"),
        zipCode: get("postal_code"),
      };
    },
  },

  mounted() {
    this.$root.$on("openNewHotelModal", (hotelData) => {
      this.hotelData = hotelData;
      console.log(this.hotelData);
      var elem = this.$refs.openModalNewHotel;
      if (elem) {
        elem.click();

        if (hotelData?.place?.name) {
          this.name = hotelData.place.name;
        }

        if (hotelData?.place?.formatted_phone_number) {
          this.details.mob = hotelData.place.formatted_phone_number;
        }

        if (hotelData?.place?.formatted_address) {
          this.location = hotelData.place.formatted_address;
        }

        if (hotelData?.position) {
          this.marker.position = hotelData.position;
        }

        // Parse address parts
        const addressParts = this.getAddressParts(
          hotelData.place.address_components || []
        );
        this.street = addressParts.street;
        this.city = addressParts.city;
        this.state = addressParts.state;
        this.zipCode = addressParts.zipCode;
      }
    });
  },
};
</script>

<style scoped>
.vue-map-container,
.vue-map-container .vue-map {
  width: 100% !important;
}

.profile-preview {
  display: flex;
  gap: 10px;
}
</style>
